import React from 'react';
import SectionView from "../../../../Common/Views/SectionView";
import SocialMediaPageController from "./SocialMediaPageController";

const SocialMediaSection = () => {
    return (
        <SectionView disableGutters={true} >
            <SocialMediaPageController />
        </SectionView>
    );
};

export default SocialMediaSection;